/**
 * Video reviews block on the PDP (sections/main-product.liquid, block type
 * video_reviews): tap a tile to play or pause its video, one video at a time per
 * block, with the tile's play button named for what it will do.
 *
 * This was an inline script printed once per block, twice on every PDP (the
 * desktop and mobile layouts are separate blocks). As an asset it is downloaded
 * once and cached. main-product.liquid loads it, and the homepage product
 * switcher preloads it, since a <script src> in injected section HTML never runs.
 * Tiles are bound once each; tiles that arrive with a swapped-in section (the
 * PDP family switcher, the homepage switcher, the theme editor) are bound on the
 * shopify:section:load those dispatch.
 */
(function () {
  'use strict';
  if (window.JiYuVideoReviews) return;

  /* The tiles of one block: the block's carousel carries reviews-block-<block id>. */
  function blockItems(item) {
    var carousel = item.closest('.video-reviews-carousel');
    var blockClass = carousel && Array.prototype.find.call(carousel.classList, function (c) {
      return c.indexOf('reviews-block-') === 0;
    });
    if (!blockClass) return [item];
    return document.querySelectorAll('.product-video-reviews-block .' + CSS.escape(blockClass) + ' .video-review-item');
  }

  /* A paused <video> keeps downloading: the browser buffers well ahead of the
     playhead, and each review is a single 1080p file of 25-84 MB (the only MP4
     Shopify makes for these uploads). Two taps, play then pause, kept about
     10 MB coming down over the next seconds, and a product-family switch in
     that window waited 14.5 s for its page instead of about 2 s (TASKS #177).
     So a review video that stops playing lets go of its file (its <source>
     loses src and load() aborts the download; the poster shows again) and
     picks it up from the same spot on its next tap. */
  function release(video) {
    if (video.dataset.vrReleased) return;
    // Never started loading (preload="none" and never played): nothing to stop.
    if (video.readyState === 0 && video.networkState !== 2) return;
    var sources = video.querySelectorAll('source[src]');
    if (!sources.length) return;
    video.dataset.vrResumeAt = video.ended ? '0' : String(video.currentTime || 0);
    Array.prototype.forEach.call(sources, function (source) {
      source.setAttribute('data-vr-src', source.getAttribute('src'));
      source.removeAttribute('src');
    });
    video.dataset.vrReleased = '1';
    video.load();
  }

  function restore(video) {
    if (!video.dataset.vrReleased) return;
    var resumeAt = parseFloat(video.dataset.vrResumeAt) || 0;
    Array.prototype.forEach.call(video.querySelectorAll('source[data-vr-src]'), function (source) {
      // Resume through the URL's media fragment (#t=), the one start position
      // both engines honour. iOS Safari ignores a currentTime set before the
      // metadata loads, and the markup's own #t=0.1 seek undoes one set on
      // loadedmetadata. A video that ended starts again at 0.1.
      var src = source.getAttribute('data-vr-src').replace(/#t=[^#]*$/, '');
      source.setAttribute('src', src + '#t=' + (resumeAt > 0 ? resumeAt.toFixed(2) : '0.1'));
      source.removeAttribute('data-vr-src');
    });
    delete video.dataset.vrReleased;
    video.load();
  }

  /* Stop every review video under root and let go of its file. The product
     switchers call this as a switch starts, so their page fetch doesn't share
     the connection with a video nobody will see. A playing video is only
     paused here: its pause handler resets the tile and releases the file.
     Releasing it here as well would call load() before that handler runs,
     and load() cancels the queued pause event, leaving the tile marked as
     playing. */
  function stopAll(root) {
    (root || document).querySelectorAll('.product-video-reviews-block video').forEach(function (video) {
      if (video.paused) release(video);
      else video.pause();
    });
  }

  function bindItem(item) {
    if (item.dataset.vrInit) return; // one bind per item, even if re-injected
    item.dataset.vrInit = '1';

    var video = item.querySelector('video');
    if (!video) return;

    // The tile's play <button> (snippets/video-review-play-button.liquid) is the
    // pause control while the video plays; keep its name in step.
    var playButton = item.querySelector('button.video-play-btn');
    function labelPlayButton(playing) {
      if (!playButton) return;
      var label = playButton.getAttribute(playing ? 'data-label-pause' : 'data-label-play');
      if (label) playButton.setAttribute('aria-label', label);
    }

    // Click to play/pause.
    item.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var isPlaying = !video.paused;

      // Pause the block's other videos.
      Array.prototype.forEach.call(blockItems(item), function (otherItem) {
        var otherVideo = otherItem.querySelector('video');
        if (otherVideo && otherVideo !== video) {
          otherVideo.pause();
          otherItem.classList.remove('playing');
        }
      });

      if (isPlaying) {
        video.pause();
        item.classList.remove('playing');
      } else {
        // The markup carries data-poster, not poster (see the Liquid comment in
        // main-product.liquid). Set it now, from cache, so the thumbnail holds
        // until the first frame arrives.
        if (video.dataset.poster && !video.hasAttribute('poster')) {
          video.setAttribute('poster', video.dataset.poster);
        }
        restore(video);
        video.play().catch(function (error) {
          console.log('Video play error:', error);
        });
        item.classList.add('playing');
      }
    });

    // Show the play button when the video ends.
    video.addEventListener('ended', function () {
      item.classList.remove('playing');
      labelPlayButton(false);
    });

    video.addEventListener('play', function () {
      item.classList.add('playing');
      labelPlayButton(true);
    });

    video.addEventListener('pause', function () {
      item.classList.remove('playing');
      labelPlayButton(false);
      release(video);
    });
  }

  function init() {
    document.querySelectorAll('.product-video-reviews-block .video-review-item').forEach(bindItem);
  }

  window.JiYuVideoReviews = { init: init, stopAll: stopAll };
  init();
  document.addEventListener('shopify:section:load', init);
})();
